import Service from "../Service";
const resource = "whatsapp/"

export default {
    save(obj, requestID) {
        return Service.post(resource + "save", obj, {
            params: { requestID: requestID },
        });
    },
    pagination(obj, requestID) {
        return Service.post(resource + "pagination", obj, {
            params: { requestID: requestID },
        });
    },
    sendTemplateMeta(payload, requestID) {
        return Service.post(resource + "send-template-meta", payload, {
            params: { requestID: requestID },
        });
    },
    sendCustomText(payload, requestID) {
        return Service.post(resource + "send-custom-text", payload, {
            params: { requestID: requestID },
        });
    },
};